export const NO_LOCAL_SIGNING_KEY_MESSAGE =
    'Self-custody signing is enabled, but this device does not have a local key set up.'

type FeatureEntry = string | { name?: string } | null | undefined

export function hasClientSigningFeature(features: FeatureEntry[] | null | undefined): boolean {
    return (features || []).some(
        feature => (typeof feature === 'string' ? feature : feature?.name) === 'use_client_signing',
    )
}

// The device that signs a self-custody payment: the one holding this user's local client share.
// Returns undefined for server-key users; throws when client signing is on but this browser has
// no local key, so callers show a real error instead of starting a payment nobody can sign.
// With serverFallback (Treechat still holds the wallet) a browser without the key returns
// undefined as well: the payment goes without a device id and Treechat signs it.
export async function resolveClientSigningDeviceId({
    userId,
    features,
    getClientShare,
    serverFallback = false,
}: {
    userId: string | null | undefined
    features: FeatureEntry[] | null | undefined
    getClientShare: (userId: string) => Promise<{ deviceId?: string | null } | null>
    serverFallback?: boolean
}): Promise<string | undefined> {
    if (!userId || !hasClientSigningFeature(features)) return undefined

    const clientShare = await getClientShare(userId)
    if (clientShare?.deviceId) return clientShare.deviceId
    if (serverFallback) return undefined
    throw new Error(NO_LOCAL_SIGNING_KEY_MESSAGE)
}
